import { useRenders } from 'global/cnr/contexts/useHelpers/useRenders'
import { useStyles } from 'global/cnr/contexts/useHelpers/useStyles'
import { formatItem, formatTypes } from 'global/common/dateFormatting'
import { uniqueKey } from 'global/common/keys'
import { gEnums } from 'global/enums/globalEnums'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import _ from 'lodash'
import { useEffect, useMemo, useRef } from 'react'
import { Button, Icon, Menu } from 'semantic-ui-react'

export const _swiperMenuTypes = {
  menu: 'menu',
  buttons: 'buttons'
}

export function SwiperMenu({
  swipeContentType,
  menuItems,
  extraButtons,
  groupDataProps,
  swiperMenuType,
  handleIndexChange,
  activeIndex,
}) {

  useRenders('SwiperMenu', true, true)

  const _activeIndex = activeIndex || 0

  const styleFns = useStyles()

  const tabStyles = useMemo(() => ({
    tabsSnC: styleFns.setStyleAndClass({ item: gEnums.projectStyles.tabs }),
    tabsSnC_active: styleFns.setStyleAndClass({ item: gEnums.projectStyles.tabs, forActive: true }),
    tabsSnC_line: styleFns.setStyleAndClass({ item: gEnums.projectStyles.tabs, forLine: true }),
  }), [])

  const menuItems_sorted = useMemo(() => {
    const sorted = _.sortBy(menuItems, 'position')
    return sorted
  }, [menuItems])

  const { tabsSnC, tabsSnC_active, tabsSnC_line } = tabStyles

  const activeSnC = {
    className: 'swipe-tab',
    style: { ...tabsSnC_line.style, ...tabsSnC_active.style },
  }

  const menuItemStyle = (isActive) => {
    return isActive ? activeSnC : tabsSnC
  }

  /* ------------------------------------------------------------------ */
  /* refs + effects */
  /* ------------------------------------------------------------------ */

  const outerRef = useRef(null)

  useEffect(() => {
    if (!outerRef.current) return

    const container = outerRef.current
    const innerWrapper = container.firstElementChild
    const button = innerWrapper?.children?.[_activeIndex]

    if (!button) return

    const containerWidth = container.offsetWidth
    const buttonLeft = button.offsetLeft
    const buttonWidth = button.offsetWidth

    const scrollPosition =
      buttonLeft - containerWidth / 2 + buttonWidth / 2

    container.scrollTo({ left: scrollPosition, behavior: 'smooth' })
  }, [_activeIndex])

  /* ------------------------------------------------------------------ */
  /* derived items */
  /* ------------------------------------------------------------------ */

  const items = useMemo(() => {
    if (_.isEmpty(menuItems_sorted)) { return [] }
    return _.map(menuItems_sorted, (item, idx) => {
      const { groupByProp, icon, ddc } = item ?? {}
      let caption = item.caption ?? item.display?.caption
      if (groupByProp === 'startDate') {
        caption = formatItem(formatTypes.dateDayMonth, caption)
      }
      return {
        key: item.key ?? idx,
        icon,
        caption: caption || _.startCase(item?.key) || _.startCase(idx),
        ddc,
      }
    })
  }, [swipeContentType, menuItems_sorted])

  if (_.isEmpty(items)) return null

  /* ------------------------------------------------------------------ */
  /* render helpers */
  /* ------------------------------------------------------------------ */

  const buttons = () => _.map(items, (item, idx) => {
    const { key, caption, icon, iconColor, ddc } = item
    const _key = key || idx
    const _color = _activeIndex === idx ? 'blue' : null
    if (iconColor) { _color = iconColor }
    return ddc ? ddc : <Button
      icon={icon ? true : false}
      key={uniqueKey('sw', 'btn', _key)}
      color={_color}
      className={_activeIndex === idx ? 'btn-sel' : null}
      onClick={() => handleIndexChange(idx)}
    >
      {icon && <Icon name={icon} />}
      {!icon && caption}
    </Button>
  })

  const menu_items = () => _.map(items, (item, idx) => {
    const { key, caption, icon } = item
    const isActive = Number(_activeIndex) === Number(idx)
    return <Menu.Item
      {...menuItemStyle(isActive)}
      key={key}
      active={isActive}
      onClick={() => handleIndexChange(idx)}
    >
      {icon ? <Icon name='cog' /> : caption}
    </Menu.Item>
  })

  const renderButtons = () => (
    <div className='ms-button-group swr' style={tabStyles.tabsSnC.style}>
      <Button.Group
        className='swipe-tab-container swr'
        size='mini'
      >
        {buttons()}
      </Button.Group>
    </div>
  )

  const ims_menu = () => {
    console.log(items)
    const oc = (item) => {
      console.log(item)
      handleIndexChange(item?.key)
    }
    return <ItemMenuSquares
      menuItems={items}
      imsType={_imsTypes.menu}
      onClick={oc}
      activeItem={activeIndex}
    />
  }

  const renderMenu = () => (
    <div
      ref={outerRef}
      className='swipe-tab-container'
      style={{ overflowX: 'auto', display: 'flex', whiteSpace: 'nowrap' }}
    >
      {/* {ims_menu()} */}
      <Menu
        style={{ display: 'inline-flex' }}
        pointing
        secondary
        className='swipe-tab-container'
        {...tabsSnC}>
        {menu_items()}
      </Menu>
    </div>
  )

  /* ------------------------------------------------------------------ */
  /* final render */
  /* ------------------------------------------------------------------ */

  return swiperMenuType === _swiperMenuTypes.buttons ? renderButtons() : renderMenu()
}
